import React from 'react';
import styled from 'styled-components';

import HexagonBaseBlueSvg from '../media/hexagonIconImage/hexagon_base_blue.svg';
import HexagonBaseBlueOrangeSvg from '../media/hexagonIconImage/hexagon_base_blue_orange.svg';
import HexagonBaseBlueOrangeWhiteSvg from '../media/hexagonIconImage/hexagon_base_blue_orange_white.svg';

import {pxToEm} from './globalStyles';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  position: relative;
`;

const StyledBaseBackgroundImg = styled.img<{heightPx: number}>`
  height: ${props => pxToEm(props.heightPx)}em;
`;

const baseSvgShadowSizePx = 10;
const StyledIconImg = styled.img<{baseBgHeightPx: number}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: ${props => pxToEm(props.baseBgHeightPx) - pxToEm(2 * baseSvgShadowSizePx)}em;
`;

//#endregion

export enum HexagonBaseBg {
  Blue,
  BlueOrange,
  BlueOrangeWhite
}

// already with shadow 10px considered
export enum HexagonSize {
  Big = 134,
  Normal = 116,
  Small = 72
}

interface Props {
  iconSrc: string;
  baseBg?: HexagonBaseBg;
  size?: HexagonSize;
  className?: string;
}

const HexagonIconImage: React.FunctionComponent<Props> = ({
  iconSrc,
  baseBg = HexagonBaseBg.Blue,
  size = HexagonSize.Normal,
  className
}) => {
  const bgSrc =
    baseBg === HexagonBaseBg.BlueOrangeWhite
      ? HexagonBaseBlueOrangeWhiteSvg
      : baseBg === HexagonBaseBg.BlueOrange
      ? HexagonBaseBlueOrangeSvg
      : HexagonBaseBlueSvg;

  return (
    <StyledWrapperDiv className={className}>
      <StyledBaseBackgroundImg src={bgSrc} heightPx={size} alt="Hexagon base" />
      <StyledIconImg src={iconSrc} baseBgHeightPx={size} alt="White Bitmovin icon" />
    </StyledWrapperDiv>
  );
};

export default HexagonIconImage;
